<script>
import AjaxTypeAheadControl from "./AjaxTypeAheadControl";
import LocationApi from "@/api/Location";

export default {
  name: "LocationTypeAheadControl",
  extends: AjaxTypeAheadControl,
  props: {
    onInputChange: {
      type: Function,
      default: query => LocationApi.query(query).then(res => res.results)
    },
    getListText: {
      type: Function,
      default: item =>
        `${item.name}<br/><small>${item.address}, ${item.city}</small>`
    }
  }
};
</script>
